import { CreateRfqResponse } from '@/types/generated/public_api'

/**
 * The handle `create_rfq` hands back. A manual RFQ returns an `rfqId` (the key for
 * accept/cancel + stream matching); an auto RFQ returns a `correlationId` (public-api
 * can't know the algo id — you observe the algo on the AlgoState stream and only match
 * a start-FAILURE by correlation_id). `unknown` should never happen, but we surface it
 * rather than guess.
 */
export type RfqCreateHandle =
  | { mode: 'manual'; rfqId: string }
  | { mode: 'auto'; correlationId: string }
  | { mode: 'unknown' }

export function interpretCreateRfqResponse(res: CreateRfqResponse): RfqCreateHandle {
  if (res.rfqId) return { mode: 'manual', rfqId: res.rfqId }
  if (res.correlationId) return { mode: 'auto', correlationId: res.correlationId }
  return { mode: 'unknown' }
}
